
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Base Firebase configuration that can be used by both projects
const firebaseConfig = {
  apiKey: "AIzaSyBs2b6Uq7bQkee4T0N5qwmbgUBmVXTc8gQ",
  authDomain: "ahavex.firebaseapp.com",
  databaseURL: "https://ahavex-default-rtdb.firebaseio.com",
  projectId: "ahavex",
  storageBucket: "ahavex.firebasestorage.app",
  messagingSenderId: "284414323946",
  appId: "1:284414323946:web:25f5c096fbf2dfb83abb93",
  measurementId: "G-GN76GYT3RV"
};

// Add configuration for ahavextest project
const testFirebaseConfig = {
  // The test project shares most resources with the main project
  // but has its own project ID and possibly other specific settings
  ...firebaseConfig,
  projectId: "ahavextest",
  // If there are other test-specific settings, they would go here
};

// Determine which configuration to use based on the environment
// For production builds, you would set NODE_ENV to 'production'
const isTestEnvironment = import.meta.env.VITE_FIREBASE_ENV === 'test';
const currentConfig = isTestEnvironment ? testFirebaseConfig : firebaseConfig;

// Initialize Firebase with the appropriate configuration
const app = initializeApp(currentConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export default app;
